import { render, staticRenderFns } from "./StylesAltum.vue?vue&type=template&id=d14830ec&"
import script from "./StylesAltum.vue?vue&type=script&lang=js&"
export * from "./StylesAltum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports